/* global Event */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
import React, { PureComponent, createRef } from "react";
import propTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { injectIntl } from "react-intl";
import { Popover } from "react-tiny-popover";
import eventBus from "../utils/eventBus";
import Icon from "./Icon";
var canNavigate = function() {
    return !document.querySelector(".DraftEditor-root");
};
var hasSomeParentClass = function(element, className) {
    return !!element && (element.classList.contains(className) || hasSomeParentClass(element.parentElement, className));
};
var hasSomeParentAttribute = function(element, attr) {
    return !!element && (element.getAttribute(attr) || hasSomeParentAttribute(element.parentElement, attr));
};
var AppChartNavigation = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(AppChartNavigation, PureComponent);
    var _super = _createSuper(AppChartNavigation);
    function AppChartNavigation() {
        _classCallCheck(this, AppChartNavigation);
        var _this;
        _this = _super.apply(this, arguments);
        _this.tooltipRef = /*#__PURE__*/ createRef();
        _this.state = {
            isPopoverOpen: false
        };
        _this.renderConfirmation = function() {
            var _this_props = _this.props, intl = _this_props.intl, next = _this_props.next;
            return /*#__PURE__*/ React.createElement("div", {
                className: "chart-nav--confirm"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "chart-nav--confirm__info"
            }, intl.formatMessage({
                id: "ui.exam.confirm.info",
                defaultMessage: "You haven't answered all the questions in this exam. These will count as incorrectly answered for your result. Do you really want to finish the exam?"
            })), /*#__PURE__*/ React.createElement("div", {
                className: "chart-nav--confirm__button-container"
            }, /*#__PURE__*/ React.createElement("button", {
                className: "chart-nav--confirm__continue-exam",
                onClick: function() {
                    return ReactTooltip.hide(_this.confirmRef);
                }
            }, intl.formatMessage({
                id: "ui.exam.confirm.continue",
                defaultMessage: "No, continue exam"
            })), /*#__PURE__*/ React.createElement("button", {
                className: "chart-nav--confirm__finish-exam",
                onClick: next
            }, intl.formatMessage({
                id: "ui.exam.confirm.finish",
                defaultMessage: "Yes, finish exam"
            }))));
        };
        _this.onClickLink = function(evnt) {
            var _this_props = _this.props, next = _this_props.next, prev = _this_props.prev, goTo = _this_props.goTo, nextAllowed = _this_props.nextAllowed, prevAllowed = _this_props.prevAllowed, currentSlide = _this_props.currentSlide, setUIVisibilityState = _this_props.setUIVisibilityState;
            if (evnt.target && hasSomeParentClass(evnt.target, "tinyaction-next") && nextAllowed) {
                evnt.preventDefault();
                next();
            }
            if (evnt.target && hasSomeParentClass(evnt.target, "tinyaction-prev") && prevAllowed) {
                evnt.preventDefault();
                prev();
            }
            if (evnt.target && hasSomeParentClass(evnt.target, "chart-renderer") && hasSomeParentAttribute(evnt.target, "data-node-ref")) {
                evnt.preventDefault();
                var target = evnt.target.getAttribute("data-node-ref") || evnt.target.closest("[data-node-ref]") && evnt.target.closest("[data-node-ref]").getAttribute("data-node-ref");
                goTo(null, parseInt(target, 10), currentSlide);
            }
            if (evnt.target && hasSomeParentClass(evnt.target, "social-app") && hasSomeParentAttribute(evnt.target, "data-node-ref")) {
                evnt.preventDefault();
                var target1 = evnt.target.getAttribute("data-node-ref") || evnt.target.closest("[data-node-ref]") && evnt.target.closest("[data-node-ref]").getAttribute("data-node-ref");
                goTo(parseInt(target1, 10), undefined, currentSlide);
            }
            if (evnt.target && hasSomeParentClass(evnt.target, "notification-dialog") && hasSomeParentAttribute(evnt.target, "data-node-ref")) {
                evnt.preventDefault();
                var target2 = evnt.target.getAttribute("data-node-ref") || evnt.target.closest("[data-node-ref]") && evnt.target.closest("[data-node-ref]").getAttribute("data-node-ref");
                goTo(parseInt(target2, 10), undefined);
            }
            if (evnt.target && hasSomeParentClass(evnt.target, "quick-favourites") && !hasSomeParentClass(evnt.target, "slide-link-emulated") && hasSomeParentAttribute(evnt.target, "data-node-ref")) {
                evnt.preventDefault();
                var target3 = evnt.target.getAttribute("data-node-ref") || evnt.target.closest("[data-node-ref]") && evnt.target.closest("[data-node-ref]").getAttribute("data-node-ref");
                var shouldJumpBack = evnt.target.getAttribute("data-jump-back") || evnt.target.closest("[data-jump-back]") && evnt.target.closest("[data-jump-back]").getAttribute("data-jump-back");
                goTo(null, parseInt(target3, 10), shouldJumpBack ? currentSlide : undefined, currentSlide);
                setUIVisibilityState({
                    quickFavourites: false
                });
            }
        };
        _this.goToPrevious = function() {
            var _this_props = _this.props, prev = _this_props.prev, prevVisible = _this_props.prevVisible, visible = _this_props.visible;
            if (canNavigate() && prevVisible && visible) {
                _this.clearFocus();
                prev();
            }
        };
        _this.goToNext = function() {
            var _this_props = _this.props, next = _this_props.next, nextVisible = _this_props.nextVisible, visible = _this_props.visible;
            if (canNavigate() && nextVisible && visible) {
                _this.clearFocus();
                next();
            }
        };
        _this.handleDoubleClick = function(evnt) {
            evnt.preventDefault();
        };
        _this.clearFocus = function() {
            if (document.body) {
                document.body.focus();
            }
        };
        return _this;
    }
    var _proto = AppChartNavigation.prototype;
    _proto.componentDidMount = function componentDidMount() {
        eventBus.register("j", "app", this.goToPrevious);
        eventBus.register("k", "app", this.goToNext);
        document.body.addEventListener("click", this.onClickLink);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        eventBus.unregister("j", "app");
        eventBus.unregister("k", "app");
        document.body.removeEventListener("click", this.onClickLink);
    };
    _proto.render = function render() {
        var _this = this;
        var _this_props = this.props, visible = _this_props.visible, nextAllowed = _this_props.nextAllowed, prevAllowed = _this_props.prevAllowed, next = _this_props.next, prev = _this_props.prev, goTo = _this_props.goTo, originSlide = _this_props.originSlide, intl = _this_props.intl, nextVisible = _this_props.nextVisible, prevVisible = _this_props.prevVisible, allowExamNavigation = _this_props.allowExamNavigation, isLastExamQuestion = _this_props.isLastExamQuestion;
        var isPopoverOpen = this.state.isPopoverOpen;
        return visible ? /*#__PURE__*/ React.createElement("div", {
            className: "app-chart-nav"
        }, nextVisible && allowExamNavigation && isLastExamQuestion && /*#__PURE__*/ React.createElement(Popover, {
            className: "chart-nav--confirm",
            isOpen: isPopoverOpen,
            position: "top",
            content: /*#__PURE__*/ React.createElement("div", {
                className: "chart-nav--confirm__content"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "chart-nav--confirm__info"
            }, intl.formatMessage({
                id: "ui.exam.confirm.info",
                defaultMessage: "You haven't answered all the questions in this exam. These will count as incorrectly answered for your result. Do you really want to finish the exam?"
            })), /*#__PURE__*/ React.createElement("div", {
                className: "chart-nav--confirm__button-container"
            }, /*#__PURE__*/ React.createElement("button", {
                className: "chart-nav--confirm__continue-exam",
                onClick: function() {
                    return _this.setState({
                        isPopoverOpen: false
                    });
                }
            }, intl.formatMessage({
                id: "ui.exam.confirm.continue",
                defaultMessage: "No, continue exam"
            })), /*#__PURE__*/ React.createElement("button", {
                className: "chart-nav--confirm__finish-exam",
                onClick: function() {
                    _this.setState({
                        isPopoverOpen: false
                    });
                    next();
                }
            }, intl.formatMessage({
                id: "ui.exam.confirm.finish",
                defaultMessage: "Yes, finish exam"
            }))))
        }, /*#__PURE__*/ React.createElement("button", {
            key: "skip",
            className: "chart-nav".concat(!nextAllowed && " chart-nav--disabled" || "", " next"),
            onClick: function() {
                _this.setState({
                    isPopoverOpen: true
                });
            },
            onDoubleClick: this.handleDoubleClick,
            "aria-label": "Skip to next Slide"
        })), nextVisible && allowExamNavigation && !isLastExamQuestion && /*#__PURE__*/ React.createElement(ReactTooltip, {
            id: "chart-nav--tooltip",
            place: "top",
            type: "dark",
            effect: "solid",
            delayHide: 100,
            getContent: function() {
                return /*#__PURE__*/ React.createElement("div", {
                    className: "chart-nav--skip"
                }, /*#__PURE__*/ React.createElement("span", null, intl.formatMessage({
                    id: "ui.exam.skip",
                    defaultMessage: "Skip this question"
                })));
            }
        }), nextVisible ? allowExamNavigation ? !isLastExamQuestion ? /*#__PURE__*/ React.createElement("button", {
            "data-tip": "",
            "data-for": "chart-nav--tooltip",
            key: "skip2",
            className: "chart-nav".concat(!nextAllowed && " chart-nav--disabled" || "", " next"),
            onClick: function() {
                ReactTooltip.hide();
                next();
            },
            onDoubleClick: this.handleDoubleClick,
            "aria-label": "Skip to next Slide"
        }) : null : /*#__PURE__*/ React.createElement("button", {
            key: "next",
            className: "chart-nav".concat(!nextAllowed && " chart-nav--disabled" || "", " next"),
            onClick: next,
            onDoubleClick: this.handleDoubleClick,
            "aria-label": intl.formatMessage({
                id: "ui.next_slide",
                defaultMessage: "Next slide"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "nav-next",
            size: "m"
        })) : null, prevVisible && /*#__PURE__*/ React.createElement("button", {
            key: "prev",
            className: "chart-nav".concat(!prevAllowed && " chart-nav--disabled" || ""),
            onClick: prev,
            onDoubleClick: this.handleDoubleClick,
            "aria-label": intl.formatMessage({
                id: "ui.prev_slide",
                defaultMessage: "Previous slide"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "nav-back",
            size: "m"
        })), !!originSlide && /*#__PURE__*/ React.createElement("button", {
            key: "back",
            title: intl.formatMessage({
                id: "ui.back",
                defaultMessage: "Go to slide {name}"
            }, {
                name: originSlide.name
            }),
            className: "chart-nav chart-nav--back",
            onClick: function() {
                return goTo(originSlide.id);
            },
            onDoubleClick: this.handleDoubleClick,
            "aria-label": intl.formatMessage({
                id: "ui.prev_visited",
                defaultMessage: "Jump back to previously visited slide"
            })
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: "nav-smart-back",
            size: "m"
        }))) : null;
    };
    return AppChartNavigation;
}(PureComponent);
AppChartNavigation.propTypes = {
    nextAllowed: propTypes.bool,
    prevAllowed: propTypes.bool,
    visible: propTypes.bool,
    allowExamNavigation: propTypes.bool,
    next: propTypes.func.isRequired,
    prev: propTypes.func.isRequired,
    goTo: propTypes.func.isRequired,
    originSlide: propTypes.object
};
export var Component = AppChartNavigation;
export default injectIntl(AppChartNavigation);
